import React from 'react';
import { Navigate } from 'react-router-dom';

// Pantalla vieja de leads: leía demo_requests y solo alternaba pendiente/contactado,
// con lo que pisaba estados del embudo nuevo (demo, cliente, respondió...).
// El seguimiento completo vive en Superadmin → Solicitudes Demo.
export default function Prospectos() {
  return <Navigate to="/sistema/super-admin-demo-requests" replace />;
}
